import React from 'react';
import './blog-post.css';
import './blog-slides.css';
import hiya from './pictures/hiya.jpeg';
import hiyaQuestions from './pictures/hiyaquestions.jpeg';

const HiyaFireside = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header></header>
                <section>
                    <h2>Fireside Chat with Hiya</h2>
                    <p className="site-post-meta">February 23, 2026</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>
                    Thank you so much to everyone who came to our WiC x Hiya Fireside Chat! We had the amazing opportunity to get advice on what it's like working in industry at this moment, recruiting tips, hear about hiring success stories, and more. We also had the opportunity to learn more about Hiya, what it's like to work at Hiya, the problems that engineers are working on there, and interview tips. 
                    <br></br>
                    We also got to hear about our panel's experience with being a woman in the industry, in Hiya, and in the workplace! We hope everyone enjoyed the Fireside chat. Big thank you to Alex and Samira for their time and sharing so much about their work and Hiya!
                    <br></br>
                    <br></br>
                    </p>
                    <img src={hiya} alt="Slides from Hiya event"/>
                    <img src={hiyaQuestions} alt="Asking questions to our panel"/>
                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default HiyaFireside;